import { onMounted, onUnmounted, ref } from 'vue';
import { getCurrentOrientationAngle } from '@/utils/camera-capture';

/** The screen's rotation in degrees (0, 90, 180, 270), kept up to date while mounted. */
export function useScreenOrientationAngle() {
  const angle = ref(0);
  const syncAngle = () => {
    angle.value = getCurrentOrientationAngle();
  };

  onMounted(() => {
    syncAngle();
    screen.orientation?.addEventListener('change', syncAngle);
    window.addEventListener('orientationchange', syncAngle);
  });
  onUnmounted(() => {
    screen.orientation?.removeEventListener('change', syncAngle);
    window.removeEventListener('orientationchange', syncAngle);
  });

  return angle;
}
